import React, { useState, useEffect } from 'react';
import { Table, Button, Tag, Space, Modal, Form, Input, Select, message, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, EyeOutlined, CopyOutlined } from '@ant-design/icons';
import { templatesApi } from '../services/api';

const { TextArea } = Input;

const Templates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [previewContent, setPreviewContent] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => { fetchTemplates(); }, []);

  const fetchTemplates = async () => {
    setLoading(true);
    try { setTemplates((await templatesApi.list({})).data); }
    catch { message.error('템플릿 로드 실패'); }
    finally { setLoading(false); }
  };

  const handleSave = async (values) => {
    try {
      if (selectedTemplate) await templatesApi.update(selectedTemplate.id, values);
      else await templatesApi.create(values);
      message.success('저장됨'); setIsModalOpen(false); form.resetFields(); setSelectedTemplate(null); fetchTemplates();
    } catch { message.error('저장 실패'); }
  };

  const handleDelete = async (id) => { try { await templatesApi.delete(id); message.success('삭제됨'); fetchTemplates(); } catch { message.error('실패'); } };

  const handlePreview = async (t) => {
    try { setPreviewContent((await templatesApi.preview(t.id, {})).data); setSelectedTemplate(t); setIsPreviewOpen(true); }
    catch { message.error('미리보기 실패'); }
  };

  const handleDuplicate = async (id) => { try { await templatesApi.duplicate(id); message.success('복제됨'); fetchTemplates(); } catch { message.error('실패'); } };

  const columns = [
    { title: '템플릿명', dataIndex: 'name' },
    { title: '카테고리', dataIndex: 'category', render: (c) => <Tag>{c || '기타'}</Tag> },
    { title: '제목', dataIndex: 'subject_template', ellipsis: true },
    { title: '상태', dataIndex: 'is_active', render: (a) => <Tag color={a ? 'green' : 'default'}>{a ? '활성' : '비활성'}</Tag> },
    { title: '', key: 'action', render: (_, r) => (
      <Space size="small">
        <Button type="text" icon={<EyeOutlined />} onClick={() => handlePreview(r)} />
        <Button type="text" icon={<EditOutlined />} onClick={() => { setSelectedTemplate(r); form.setFieldsValue(r); setIsModalOpen(true); }} />
        <Button type="text" icon={<CopyOutlined />} onClick={() => handleDuplicate(r.id)} />
        <Popconfirm title="삭제?" onConfirm={() => handleDelete(r.id)}><Button type="text" danger icon={<DeleteOutlined />} /></Popconfirm>
      </Space>
    )},
  ];

  return (
    <div>
      <div className="page-header"><h1>이메일 템플릿</h1></div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => { form.resetFields(); setSelectedTemplate(null); setIsModalOpen(true); }}>새 템플릿</Button>
      </div>
      <Table columns={columns} dataSource={templates} rowKey="id" loading={loading} />
      <Modal title={selectedTemplate ? '수정' : '새 템플릿'} open={isModalOpen} onCancel={() => { setIsModalOpen(false); setSelectedTemplate(null); }} footer={null} width={800}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name="name" label="템플릿명" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="category" label="카테고리"><Select placeholder="선택" options={[{ value: 'welcome', label: '환영' }, { value: 'newsletter', label: '뉴스레터' }, { value: 'promotion', label: '프로모션' }]} /></Form.Item>
          <Form.Item name="subject_template" label="제목" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="html_content" label="HTML" rules={[{ required: true }]}><TextArea rows={10} /></Form.Item>
          <Form.Item name="variables" label="변수"><Select mode="tags" /></Form.Item>
          <Form.Item><Space><Button type="primary" htmlType="submit">{selectedTemplate ? '수정' : '생성'}</Button><Button onClick={() => setIsModalOpen(false)}>취소</Button></Space></Form.Item>
        </Form>
      </Modal>
      <Modal title={`미리보기: ${selectedTemplate?.name}`} open={isPreviewOpen} onCancel={() => setIsPreviewOpen(false)} footer={null} width={700}>
        {previewContent && <div><p><strong>제목:</strong> {previewContent.subject}</p><div style={{ background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 4, padding: 16, maxHeight: 400, overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: previewContent.html_content }} /></div>}
      </Modal>
    </div>
  );
};

export default Templates;
